const MENU_TYPES = {
    PROFILE: "profile",
    DETAIL: "detail",
    VISIBILITY: "visibility",
    WALLET: "wallet",
    NEW_TEMPLATE: "new-template",
    TEMPLATES: "templates",
    CHAT_INITIATOR_TEMPLATE: "chat-initiator-template",
    BROADCAST_REQUESTS: "broadcast-requests",
    CUSTOMER_GROUPS: "customer-groups",
    NUMBERS: "numbers",
    ALL_CONTACTS: "all-contacts",
    DAILY_USAGES: "daily-usages",
    VOICE_CONFIGURATION: "voice-configuration",
    COMPARISON: "comparison",
    DEVELOPER: "developer",
};

const Items = (that) => [
    {
        enabled: true,
        key: MENU_TYPES.PROFILE,
        label:  that?.$t("multi_whatsapp_api.profile") || "Profile",
        icon: {
            type: "material-icons",
            name: "badge",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.DETAIL,
        label: that?.$t("multi_whatsapp_api.detail") || "Detail",
        icon: {
            type: "material-icons",
            name: "info",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.VISIBILITY,
        label: that?.$t("multi_whatsapp_api.visibility") || "Visibility",
        icon: {
            type: "material-icons",
            name: "visibility",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.WALLET,
        label: that?.$t("settings.wallet") || "Wallet",
        icon: {
            type: "material-icons",
            name: "account_balance_wallet",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.NEW_TEMPLATE,
        label: that?.$t("multi_whatsapp_api.new_template") || "New Template",
        icon: {
            type: "material-icons",
            name: "newspaper",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.TEMPLATES,
        label: that?.$t("multi_whatsapp_api.templates") || "Templates",
        icon: {
            type: "material-icons",
            name: "description",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.CHAT_INITIATOR_TEMPLATE,
        label: that?.$t("multi_whatsapp_api.chat_initiator_template") || "Initiator Template",
        icon: {
            type: "material-icons",
            name: "mark_chat_read",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.BROADCAST_REQUESTS,
        label: that?.$t("multi_whatsapp_api.broadcast_requests") || "Broadcast Requests",
        icon: {
            type: "material-icons",
            name: "podcasts",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.CUSTOMER_GROUPS,
        label: that?.$t("multi_whatsapp_api.customer_groups") || "Customer Groups",
        icon: {
            type: "material-icons",
            name: "group_add",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.NUMBERS,
        label: that?.$t("multi_whatsapp_api.numbers") || "Numbers",
        icon: {
            type: "material-icons",
            name: "call",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.ALL_CONTACTS,
        label: that?.$t("multi_whatsapp_api.all_contacts") || "All Contacts",
        icon: {
            type: "material-icons",
            name: "contacts",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.DAILY_USAGES,
        label: that?.$t("whatsapp_business_api.daily_usages") || "Daily Usages",
        icon: {
            type: "material-icons",
            name: "summarize",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.VOICE_CONFIGURATION,
        label: "Voice Configuration",
        icon: {
            type: "material-icons",
            name: "dialer_sip",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.COMPARISON,
        label: "WhatsApp Çözümleri Karşılaştırması",
        icon: {
            type: "material-icons",
            name: "compare",
        },
    },
    {
        enabled: true,
        key: MENU_TYPES.DEVELOPER,
        label: "Developer",
        icon: {
            type: "material-icons",
            name: "code",
        },
    },
];

export default {
    MENU_TYPES,
    Items,
};
